import { FRONTEND_ROUTES } from "@fysaro/shared";
import { ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useAppHref } from "@/utils/appUrl";

export function Pricing() {
  const { t } = useTranslation(["landing"]);
  const registerHref = useAppHref(FRONTEND_ROUTES.auth.registerClinic);

  return (
    <section
      id="pricing"
      className="bg-primary/30 border-y border-primary/10 py-16 px-6"
    >
      <div className="max-w-4xl mx-auto text-center space-y-6">
        <h2 className="text-2xl md:text-3xl font-black tracking-tight text-foreground">
          {t("landing:pricing.title")}
        </h2>

        <p className="text-muted-foreground text-sm max-w-xl mx-auto font-medium">
          {t("landing:pricing.sub_title")}
        </p>

        <div className="pt-4">
          <a
            href={registerHref}
            className="inline-flex items-center gap-2 bg-foreground text-background px-6 py-3 rounded-xl font-bold text-xs uppercase tracking-wider hover:opacity-90 transition group shadow-md"
          >
            {t("landing:pricing.main_action")}
            <ArrowRight
              size={14}
              className="group-hover:translate-x-1 transition-transform"
            />
          </a>
        </div>

        <p className="text-muted-foreground text-sm mt-4">
          {t("landing:pricing.info_message")}
        </p>
      </div>
    </section>
  );
}
